import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Product } from '../models/product.model'; 
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { VideoDialogComponent } from '../video-dialog/video-dialog.component';
import { MrpScrolltopComponent } from '../services//mrp-scrolltop/mrp-scrolltop.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-zoom',
    templateUrl: './zoom.component.html',
    styleUrls: ['./zoom.component.css'],
    imports: [MrpScrolltopComponent, MatIconButton, MatIcon, FooterComponent]
})
export class ZoomComponent implements OnInit {

  classes: Product[] = [];
  displayedColumns: string[] = ['name', 'description', 'price', 'action'];
  isLoading = false;
  isInitiatingCheckout = false;
  bannerVidVisible = true;
  noClassesMessage: string = '';
  isBrowser = false;

  constructor(private router: Router, private http: HttpClient, private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object, private cdr: ChangeDetectorRef) { 
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

     this.isLoading = true;
     if (this.isBrowser) {
          this.http.post<Product[]>('api/products/getZoomClasses.php', {}).subscribe({
              next: (data) => {

                // sort by eventDate (format "MM-DD-YYYY") ascending
                const parseEventDate = (s: string) => {
                  if (!s) return new Date(0);
                  const parts = s.split(/[-\/]/);
                  if (parts.length === 3) {
                    const month = parseInt(parts[0], 10);
                    const day = parseInt(parts[1], 10);
                    const year = parseInt(parts[2], 10);
                    return new Date(year, month - 1, day);
                  }
                  return new Date(s);
                };
                data.sort((a, b) => parseEventDate(a.eventDate).getTime() - parseEventDate(b.eventDate).getTime());

                this.classes = data;
                this.isLoading = false;
                this.cdr.markForCheck();
              },
              error: (error) => {
                console.error('Error fetching products:', error);
                this.isLoading = false;
                this.cdr.markForCheck();
              }
            });

      this.logPage('zoom');
     } else {
       this.isLoading = false;
     }
  }

  logPage(urlName: string): void {
    if (!this.isBrowser) return;
    this.http.post('/api/access/access_log.php', {urlName: urlName}).subscribe();
  }

  gotoClass(item_CODE: string){
      this.router.navigate(['/zoom-detail', item_CODE]);  
  }

  async initiateCheckout(priceId: string, mode: 'payment') {
    this.isInitiatingCheckout = true;
    this.http.post<{ sessionId: string, stripeKey: string, sessionUrl: string}>('api/create-checkout-session/create-checkout-session.php', { priceId, mode }).subscribe({
      next: async (response) => {
        // Redirect to Stripe Checkout
        this.redirectTo(response.sessionUrl);
      },
      error: (error) => {
        this.isInitiatingCheckout = false;
        console.error('Error creating checkout session:', error);
        this.cdr.markForCheck();
      }
    });
  }

  openVideoPlayer(index: number) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = false; 
      dialogConfig.autoFocus = true;
      dialogConfig.width = '80vw'; 
      dialogConfig.height = '70vh'; 
  
      // ✅ Pass the index using the `data` property
      // THIS IS AN INPUT TO VideoDialogComponent
      dialogConfig.data = { videoIndex: index };
  
      this.bannerVidVisible = false; 
  
      this.dialog.open(VideoDialogComponent, dialogConfig);
    }

  scrollTo(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      // Use scrollIntoView with 'smooth' behavior for a nice effect
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Wrapper to make redirects testable
  redirectTo(url: string): void {
    window.location.assign(url);
  }

}
